import { muiTheme } from '@tassat/payments-themes';

const muiStyles = (theme: typeof muiTheme) => ({
    checkboxField: {
        display: 'flex' as 'flex',
        '& label': {
            width: '45px',
            alignItems: 'flex-start',
            minHeight: '1rem'
        },
        '& span': {
            border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#CFCFCF'}`,
            borderRadius: '3px'
        },
        marginTop: '5px'
    },
    checkboxFieldTitle: {
        color: 'var(--Background-Colors-Tassat-Black, #202020)',
        /* Body Extra Small */
        fontSize: '0.875rem',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        marginTop: '5px'
    },
    submitError: { alignSelf: 'center' },
    flexColumn: {
        display: 'flex' as 'flex',
        flexFlow: 'column nowrap' as 'column nowrap',
        flexGrow: 1,
        alignItems: 'center' as 'center',
        marginTop: '2rem'
    },
    fieldContainer: {
        width: '100%',
        alignSelf: 'flex-start',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#FFFFFF',
        padding: '1rem 2rem',
        marginBottom: '2rem'
    },
    fieldGroupHeader: {
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        fontSize: '1.5rem',
        marginBottom: '.75rem'
    },
    dollarPrefix: {
        alignSelf: 'center',
        fontSize: '2rem',
        paddingTop: '.5rem'
    },
    legalText: {
        fontSize: '11px',
        marginTop: '3rem',
        color: 'black',
        '& a, a:hover, a:visited': { fontWeight: 'bold' }
    },
    walletBankFirmNamesContainer: { marginBottom: '.5rem' },
    walletBankFirmNames: {
        fontSize: '0.875rem',
        lineHeight: 1
    },
    submitContainer: {
        marginTop: '4rem',
        alignItems: 'center'
    },
    SelectAssetDropdownTitle: {
        color: '#375073',
        fontfamily: 'Corporate S',
        font: '1rem',
        fontstyle: 'normal',
        fontweight: 700,
        lineheight: '1.5rem',
        paddingBottom: '0.31rem'
    },
    AssetEquivalency: {
        color: '#000',
        fontfamily: 'Corporate S',
        font: '1rem',
        fontstyle: 'normal',
        fontweight: 700,
        lineheight: '1.5rem',
        paddingBottom: '0.31rem'
    },
    AvailableBalance: {
        color: 'var(--Background-Colors-Tassat-Black, #202020)',
        fontSize: '0.75rem',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal'
    },
    RecipientTitle: {
        color: 'var(--Background-Colors-Tassat-Black, #202020)',
        /* Body Extra Small */
        fontSize: '0.875rem',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal'
    },
    RecipientData: {
        color: 'var(--Background-Colors-Tassat-Black, #202020)',
        /* Body Extra Small */
        fontSize: '0.75rem',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        marginBottom: '20px'
    },
    copyButtonSmall: {
        cursor: 'pointer' as 'pointer',
        padding: '4px',
        marginLeft: '.4rem'
    },
    copyButtonIcon: {
        height: '14px',
        width: '14px'
    }
});

export default muiStyles;